<div>
    <mat-dialog-content>
        <div class="header">
            <div class="title" *ngIf=" actionType === 'add'">
                <img src="/assets/icons/Badgegreen-check.svg" alt=""/>  Added to My Favourites
            </div>
            <div class="title" *ngIf=" actionType === 'remove'">
                <img src="/assets/icons/Badgegreen-check.svg" alt="" />  Removed from My Favourites
            </div>
            <div>
                <img src="/assets/icons/Close.svg" (click)="onConfirmClick()" alt=""/>
            </div>
        </div>
        <div class="message" *ngIf=" actionType === 'add'"> '{{this.promptname}}' has been successfully added to My Favourites </div>
        <div class="message" *ngIf=" actionType === 'remove'"> '{{this.promptname}}' has been successfully removed from My Favourites </div>
    </mat-dialog-content>
</div>
